import { Nullable } from '../types/utils.type'
import { LoggerLevels } from '../utils/AppLogger'

const baseCoreUrl = 'https://testbtv.ru/'

export type EvironmentType = 'dev' | 'staging' | 'production'
const exampleSettings = {
  production: false,
  environment: 'dev' as EvironmentType,
  baseUrl: baseCoreUrl,
  beatmakerApiBaseUrl: '', // https://api.testbtv.ru/swagger/index.html (Widgets, ShoppingCarts)
  // ArtistAdministrationLink need to show admin panel on beatmakers.tv
  artistAdministrationLink: 'https://st-eng-admin-beatmaker-tv.herokuapp.com',
  // For redirect in beatmaker.tv
  bmstvUrl: 'https://st-beatmakers.herokuapp.com',
  // baseUrl: 'https://localhost:44300/',
  appLoggerLevel: LoggerLevels.none,
  urls: {
    prodspageServiceAPI: 'https://prods-page-api.testbtv.ru',
    // For save and reset colors in producer page
    saveColorsUrl: `${baseCoreUrl}/ProdsPage/Management/UpdateColors` as Nullable<string>,
    resetColors: `${baseCoreUrl}/ProdsPage/Management/ResetColors` as Nullable<string>,
    paymentDomainUrl: baseCoreUrl,
    commonDomainUrl: baseCoreUrl,
    settingsUrl: baseCoreUrl,
    currentApp: 'https://propage.dev.testbtv.ru:4003', // todo: check this property (can be deleted??),
    assetsURL: ''
  },
  routingUrl: {
    beatmakerPage: null as string | null, // empty
    beatPage: '/tracks/{{beatId}}',
    freeBeatPage: null as string | null,
    songPage: null,
    artistPage: null,
    checkoutPage: '/checkout'
  }
}

export type CoreSettingsType = typeof exampleSettings

export abstract class CoreSettingsService {
  abstract get settings(): Partial<CoreSettingsType>
}
